import React from "react";

interface AddMoreSectionProps {
  isOpen: boolean;
  toggleOpen: () => void;
  label: string;
}

export const AddMoreSection: React.FC<AddMoreSectionProps> = ({
  isOpen,
  toggleOpen,
  label,
}) => {
  return (
    <div className="flex mx-1 w-full flex-col items-center gap-2 sm:gap-3 rounded-xl bg-[#EAF1F4] p-4 sm:p-5  xl:p-[20px]">
      <div className="flex w-full items-center justify-between">
        <span className="text-sm sm:text-base md:text-lg lg:text-xl font-semibold text-gray-600">
          Add More {label}
        </span>
        <button
          onClick={toggleOpen}
          className="rounded-lg bg-white px-3 sm:px-4 lg:px-5 py-1 sm:py-1.5 lg:py-2 text-[10px] xs:text-xs sm:text-sm md:text-base lg:text-[20px] xl:text-[24px] font-medium text-[#458ef7] hover:bg-gray-100"
        >
          {isOpen ? "Close" : "Add"}
        </button>
      </div>
    </div>
  );
}